import { Component, OnInit } from '@angular/core';

declare var $: any;
declare let window: any;

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
})
export class ShareComponent implements OnInit {
  static offerPhoto = '/';
  public ShareComponent = ShareComponent;
  linkIsCopying = false;

  constructor() {
  }

  public static openModal() {
    $('.modal--share').show(300, () => {
      $('.modal--share').modal('show');
      if ($('.swiper-wrapper .box-model__photo-img')[0]) {
        this.offerPhoto = $('.swiper-wrapper .box-model__photo-img')[0].src;

        $('.sb-material-dark .sb-wrapper.sb-twitter .sb-inner .sb-content .sb-icon').html('<span class="ng-fa-icon">' +
          '<svg fill="#ffffff" height="15" viewBox="0 0 16 16" width="15" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.' +
          '75Zm-.86 13.028h1.36L4.323 2.145H2.865z"></path>\n' +
          '</svg>' +
          '</span>');
      }
    });
  }

  ngOnInit() {
  }

  copyLink() {
    const url = window.location.origin + window.location.pathname;
    window.navigator['clipboard'].writeText(url);
    this.linkIsCopying = true;

    setTimeout(() => {
      this.linkIsCopying = false;
    }, 2000);
  }
}
